import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recap-livraison',
  templateUrl: './recap-livraison.component.html',
  styleUrls: ['./recap-livraison.component.css']
})
export class RecapLivraisonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
